import React from "react";
import DropdownFilter from "../Filter/DropdownFilter";

const SpecializationFilter = ({services, handleFilter}) => {
  return (
    <DropdownFilter
      name="specialization"
      getTitle={value => services.get(value)}
      search
      title="Специализация"
      searchPlaceholder="Введите специализацию"
      values={services}
      defaultValue={0}
      onFilter={handleFilter}
    />
  )
};

export default SpecializationFilter;
